module.exports = __webpack_public_path__ + "mv.svg?3d599ae09c7c4a539b7552eec503ba73";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mv.svg
// module id = 888
// module chunks = 27